import { render, staticRenderFns } from "./TwUserProfilePasswordDialog.vue?vue&type=template&id=0c099aa4&scoped=true&"
import script from "./TwUserProfilePasswordDialog.vue?vue&type=script&lang=js&"
export * from "./TwUserProfilePasswordDialog.vue?vue&type=script&lang=js&"
import style0 from "./TwUserProfilePasswordDialog.vue?vue&type=style&index=0&id=0c099aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c099aa4",
  null
  
)

export default component.exports